import "./style.css";
import { Button } from "primereact/button";

export const TabHeader = ({
  title = "Page header title",
  Icon,
  children,
  infoButtonConfigObj,
}) => (
  <header className="page_header">
    <div className="page_header_title_container">
      <h2 className="page_header_title">
        {Icon ? <Icon /> : <></>} {title}{" "}
        {infoButtonConfigObj ? (
          <Button
            className="padding0"
            tooltip={infoButtonConfigObj.tooltip}
            icon="pi pi-info-circle"
            text
          />
        ) : (
          <></>
        )}
      </h2>
      {children}
    </div>
    <hr className="spacer" />
  </header>
);
